import { Translate } from "react-admin";
import { coefficientInMinutes } from "./actions";

export interface Time {
    hour: number;
    minute: number;
}

export const fillTime = (estimateTimeInMinute: number): Time => {
    const whereToFill = { hour: 0, minute: 0 };
    let currentEstimate = estimateTimeInMinute;
    for (const type of ["hour", "minute"]) {
        if (currentEstimate > coefficientInMinutes[type]) {
            whereToFill[type] = Math.floor(currentEstimate / coefficientInMinutes[type]);
            currentEstimate = currentEstimate - (whereToFill[type] * coefficientInMinutes[type]);
        }
    }
    return whereToFill;
};

export const translateTime = (translate: Translate, timeToTranslate: Time | number): string => {
    const time: Time = (typeof timeToTranslate === "number") ? fillTime(timeToTranslate) : timeToTranslate;
    let value = "";
    if (time.hour > 0) {
        value += translate("resources.unitTimeTranslate.hour", { smart_count: time.hour, value: time.hour })
    }
    if (time.minute > 0) {
        if (value !== "") {
            value += " ";
        }
        value += translate("resources.unitTimeTranslate.minute", { smart_count: time.minute, value: time.minute })
    }
    // On force l'affichage si aucun résultat
    if (value === "") {
        value = translate("resources.unitTimeTranslate.minute", { smart_count: 1, value: time.minute || 0 })
    }
    return value;
};